// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import { WishListCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { BuyingList } from "@store/Framework/Services/RestrictedBuyingListService";
import {
    AssignedBuyingListSelector,
    BuyingListSelector,
} from "@store/Framework/Store/Bunzl/Pages/BuyingList/buyingListSelectors";
import { useSelector } from "react-redux";

const useBuyingListState = () => {
    const dispatch = useAppDispatch();

    const buyingLists = useSelector(BuyingListSelector);
    const setBuyingLists = (buyingLists: WishListCollectionModel | undefined) =>
        dispatch({ type: "Store/Pages/buyingList/LoadBuyingList", buyingLists });
    const setBuyingListsIsLoading = (isLoading: boolean) =>
        dispatch({ type: "Store/Pages/buyingList/setIsLoading", isLoading });

    const assignedBuyingList = useSelector(AssignedBuyingListSelector);
    const setAssignedBuyingList = (assignedBuyingList: { [key: string]: string[] }) =>
        dispatch({ type: "Store/Pages/buyingList/LoadAssignedBuyingList", assignedBuyingList });
    const setActiveBuyingList = (activeBuyingList: BuyingList) =>
        dispatch({ type: "Stores/Pages/buyingList/LoadActiveBuyingList", activeBuyingList });
    const setApiParams = (apiParams: { page: number; pageSize: number; query: string; sort?: string }) =>
        dispatch({ type: "Store/Pages/buyingList/setApiParams", apiParams });
    return {
        buyingLists,
        setApiParams,
        setBuyingLists,
        assignedBuyingList,
        setAssignedBuyingList,
        setActiveBuyingList,
        setBuyingListsIsLoading,
    };
};

export default useBuyingListState;
